import React from 'react';

// Navegación compartida entre las vistas admin. El panel de contenido vive
// aparte (snapshot estático generado desde Marketing/outputs/dashboard), así
// que va como link externo.
//
// `rol` no tiene default a propósito: sin rol no se muestra ningún destino.
// Un default abierto sería justo el error que esta feature vino a evitar.
const DESTINOS = [
  { key: 'leads', label: 'LEADS', href: '/admin/leads', roles: ['admin', 'coach'] },
  { key: 'finanzas', label: 'FINANZAS', href: '/admin/finanzas', roles: ['admin', 'coach'] },
  // CRM de setting (2026-10-23): admin y setter (Julio). El setter no ve nada más.
  { key: 'setting', label: 'SETTING', href: '/admin/setting', roles: ['admin', 'setter'] },
  { key: 'email', label: 'EMAIL', href: '/admin/email', roles: ['admin'] },
  {
    key: 'contenido',
    label: 'CONTENIDO ↗',
    href: 'https://au-coaching.com/panel-rtp-x9k4m7/',
    externo: true,
    roles: ['admin'],
  },
];

const AdminNav = ({ actual, rol }) => (
  <nav className="au-admin-nav">
    {DESTINOS.filter((d) => d.roles.includes(rol)).map((d) => (
      <a
        key={d.key}
        href={d.href}
        className={`au-admin-nav-item${d.key === actual ? ' is-activo' : ''}`}
        {...(d.externo ? { target: '_blank', rel: 'noreferrer' } : {})}
      >
        {d.label}
      </a>
    ))}
  </nav>
);

export default AdminNav;
